<template>
    <content-view>
        <template #header>
            <div class="home-head">
                <bread-crumb :buttonColor="'#005AB4'"></bread-crumb>
                <v-spacer></v-spacer>
                <div class="sub-header">{{ $t("menu.overview-headline") }}</div>
            </div>
        </template>
        
        <template #content>
            <div class="grid-main-template menu">
                <router-button v-for="menu in menus" :key="menu.date"
                    :route="'menuEntry'"
                    :params="{date: menu.date}"
                    :imageURL="getImageFromMenu(menu)"
                    :icon="'mdi-silverware-fork-knife'" 
                    :iconColor="'#D3D3D3'"
                    :headlineColor="'#E5E5E5'" 
                    :text="getDayFromMenu(menu)">
                </router-button>
            </div>
        </template>
    </content-view>
</template>
<style lang="scss">

.grid-main-template.menu :first-child {
    grid-row: 1 / 3;
    .text{
        height: 21% !important;
    }
    .card-header-wrapper{
        height: 79% !important;
    }
}
</style>
<script>
import moment from 'moment';
export default {
    created() {
        let now = moment(moment.now());
        this.$store.dispatch({
            type: 'moduleMenus/fetchMenus',
            startDate: now.format('YYYY-MM-DD'),
            endDate: now.add(4, 'days').format('YYYY-MM-DD'),
        }).catch((error) => {
            if(error.response.status === 401) {
                this.$root.$emit('unauthenticated');
            } else {
                this.apiErrorMessageHandler(error);
            }
        });
    },
    methods: {
        getImageFromMenu(menu) {
            return menu.meals[0]?.image;
        },
        getDayFromMenu(menu) {
            let today = moment(moment.now()).format('YYYY-MM-DD');
            let format = 'dddd, DD.MM.YYYY';
            if(moment(menu.date).isSame(today)) {
                format = '[Heute], DD.MM.YYYY'
            }
            return moment(menu.date).locale('de').format(format);
        },
    },
    computed: {
        menus() {
            return this.$store.getters['moduleMenus/menus'];
        }
    }
}
</script>
